var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper clearfix"},[_c('div',{staticClass:"content-box"},[_c('div',{ref:"currentHeight",style:({ 'min-height':_vm.fullHeight + 'px' }),attrs:{"id":"content"}},[_c('HeaderA'),_c('router-view'),_c('BottomA')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }